import React from 'react';
import './LanguageBanner.css';

export default function LanguageBanner({
    visible,
    lang,
    showPicker,
    languages,
    onConfirm,
    onOpenPicker,
    onClosePicker,
    onSelectLanguage,
}) {
    if (!visible || !lang) return null;

    const sorted = [...languages].sort((a, b) =>
        (a.nativeLabel || a.label).localeCompare(
            b.nativeLabel || b.label,
            undefined,
            { sensitivity: 'base' },
        ),
    );

    return (
        <>
            <div className="language-banner">
                <span className="lang-flag">{lang.flag}</span>
                <span className="lang-text">{lang.bannerText}</span>
                <button type="button" className="confirm-btn" onClick={onConfirm} title="OK">
                    ✓
                </button>
                <button type="button" className="change-btn" onClick={onOpenPicker}>
                    ···
                </button>
            </div>

            {showPicker && (
                <div className="language-picker-overlay" onClick={onClosePicker}>
                    <div className="language-picker" onClick={(e) => e.stopPropagation()}>
                        <div className="language-picker-header">
                            <strong>Language</strong>
                            <button type="button" onClick={onClosePicker}>✕</button>
                        </div>
                        <div className="language-picker-list">
                            {sorted.map((item) => (
                                <button
                                    key={item.code}
                                    type="button"
                                    className={`language-picker-item${item.code === lang.code ? ' active' : ''}`}
                                    onClick={() => onSelectLanguage(item.code)}
                                >
                                    <span className="flag">{item.flag}</span>
                                    <span>{item.nativeLabel || item.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
